module.exports = __webpack_public_path__ + "img/aboutApp4.43ef0532.png";